import { DistributionSystemOverlay } from '#app/routes/mocra+/_form+/components/distribution-systems/overlay.tsx'
import { type DistributionSystemDraft } from '#app/routes/mocra+/_form+/components/distribution-systems/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: DistributionSystemDraft) => void
	readonly initialValue: DistributionSystemDraft
	readonly onClosed?: () => void
}

export function DistributionSystemEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<DistributionSystemOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
